import React from 'react';

const PlusIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 12 12">
    <path fill="#96A7B0" d="M6.901.901V4.67l.004.054c.026.211.207.375.425.375h3.769c.497 0 .901.403.901.9 0 .499-.404.902-.901.902H7.33l-.054.004c-.211.026-.375.207-.375.425v3.769c0 .497-.403.901-.901.901s-.902-.404-.902-.901V7.33l-.003-.054c-.026-.211-.207-.375-.425-.375H.901C.404 6.901 0 6.498 0 6s.404-.902.901-.902H4.67l.054-.003c.211-.026.375-.207.375-.425V.901c0-.497.403-.901.9-.901.499 0 .902.404.902.901z"/>
  </svg>
);

export default PlusIcon;
